import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {YzFileCarouselComponent} from "./yz-file-carousel.component";

@Injectable({
  providedIn: 'root'
})

export class FileCarouselService {

  constructor(public dialog: MatDialog) {
  }


  /**
   * 查看图片列表
   * @param option
   */
  viewImgFileCarousel(option: { fileList: Array<any>, index?: number }) {
    if (option.fileList.length === 0) {
      return;
    }
    this.dialog.open(YzFileCarouselComponent, {
      panelClass: 'yz-file-carousel',
      closeOnNavigation: true,
      data: {
        fileList: option.fileList,
        index: option.index == undefined ? 0 : option.index
      }
    });
  }


}

